export const management = {
  routes: [
    {
      path: "/management/announcement",
      component: () => import("../management-announcement-view"),
    },
  ],
};

export const gdpr = {
  routes: [
    {
      path: "/announcement",
      component: () => import("../announcement-view"),
    },
  ],
};

export const organization = {
  routes: [
    {
      path: "/organization/announcement",
      component: () => import("../organization-announcement-view"),
    },
  ],
};
